export default __webpack_public_path__ + "static/media/04d_fold-22.ad341c89.mp4";